module.exports = __webpack_public_path__ + "img/hxlb.340ef75f.png";